<template>

  <!-- Content -->
  <div class="admin-content">

    <div v-if="this.user.role < 3" class="row">
      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-md">Customers</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price="dataz.customers"/>
              </p>
            </div>
            <div class="pr-card-label-btn bg-dark-lighter primary-color"><span
                class="fas fa-users icon-size"></span>
            </div>
          </div>
          <p class="text-xs text-primary mb-0 mt-3">Total customers</p>

        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-md">Products</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price="dataz.products"/>
              </p>
            </div>
            <div class="pr-card-label-btn bg-dark-lighter purple-color"><span
                class="fas fa-shop icon-size"></span>
            </div>
          </div>
          <p class="text-xs text-purple mb-0 mt-3">Total Products</p>

        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-md">Process Orders</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price="dataz.process_orders"/>
              </p>
            </div>
            <div class="pr-card-label-btn bg-dark-lighter green-color"><span
                class="fas fa-hands icon-size"></span>
            </div>
          </div>
          <p class="text-xs text-green mb-0 mt-3">Orders on processing</p>

        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-md">Pending Order</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price="dataz.pending_orders"/>
              </p>
            </div>
            <div class="pr-card-label-btn bg-dark-lighter red-color">
              <span class="fas fa-times icon-size"></span>
            </div>
          </div>
          <p class="text-xs text-danger mb-0 mt-3">Total Pending Orders</p>

        </div>
      </div>
    </div>

    <div class="row align-items-stretch">
      <div class="col-12">
        <div class="card recent-orders-card mt-3">

          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-semibold">
              <span class="text-color">Recent Orders</span>
            </h5>
            <router-link :to="{ path: '/order' }"
              class="text-primary text-sm decolation-none">
              View All
            </router-link>

          </div>

          <!-- Card Body -->
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table orders-table mb-0">
                <thead class="">
                  <tr>
                    <th class="">ORDER ID</th>
                    <th class="td-wd-user">CLIENT</th>
                     <th class="">CONTACTS</th>
                   
                    <th class="td-wd-product">SUMMARY</th>
                    <th class="">TOTAL</th>
                     <th class="">DATETIME</th>
                    <th>STATUS</th>
                    <th v-if="user.role == 1" class="td-wd text-end">ASSIGN-STAFF</th>
                    <th v-if="user.role > 1" class="td-wd text-end">LOCATION</th>
                   
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in orders" :key="order.id">
                    <td class="text-primary text-sm text-bold">#{{ order.id }}</td>
                    <td class="text-sm">
                      <UserAvatar v-if="order.avator == 'user.jpg'" :fullName="order.fulname" imageUrl="" />
                      <UserAvatar v-else :fullName="order.fulname" :imageUrl="this.$store.state.img_url + order.avator" />
                    </td>
                     <td class="text-color text-sm text-bold">
                       <PhoneFormat :Phone="order.contacts"/>
                     </td>
                  
                    <td class="text-color text-sm text-muted text-capitalize">({{ order.quantity }}) {{ order.summary  }}</td>
                    <td class="text-color text-sm text-bold">
                      <PriceFormat :Price="order.total"/>
                    </td>
                      <td class="text-muted text-sm">
                        <DateFormat :Date_="order.created_at"/>
                      </td>
                    <td>
                      <OrderStatus :statusName="order.status_name" :statusID="order.status_id" />
                    </td>
                    <td v-if="user.role == 1" class=" fw-semibold text-end text-muted text-sm">
                      <span v-if="order.status_id > 1">
                        {{ order.staff }}
                      </span>

                      <!-- If pending show select -->
                      <select class="td-select" v-else v-model="this.selectedStaff" @change="handleAssign(order)">
                        <option selected disabled :value="0">
                          Select staff
                        </option>

                        <option v-for="staff in staffs" :key="staff.id" :value="staff.id">
                          {{ staff.username }}
                        </option>
                      </select>
                    </td>
                    <td  v-if="user.role > 1" class="text-color text-sm text-end text-bold">{{ order.order_location }}</td>
                    
                  </tr>

                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>


  </div>
</template>
<script>
import axios from "axios";
import UserAvatar from "@/components/UserAvatar.vue";
import OrderStatus from "@/components/OrderStatus.vue";
import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";

export default {
  components: {
    UserAvatar,
    OrderStatus,
    PriceFormat,
    PhoneFormat,
    DateFormat
  },
  data() {
    return {
      add_btn: true,
      errors: "",
      data: [],
      tags: [],
      dataz: {},
      selectedStaff: 0,
      staffs: [],
      orders: [],
      user: this.$attrs.user
    };
  },
  methods: {
      async getOrders() {
      var response = await axios
        .post(this.$store.state.api_url + "/get-orders",{limit:10})
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {

        this.orders = response.data.orders;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
     async getStaffs() {
      var response = await axios
        .post(this.$store.state.api_url + "/get-staffs",{type:"sales"})
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {

        this.staffs = response.data.staffs;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
         async dashbordDatas() {
      var response = await axios
        .get(this.$store.state.api_url + "/dashbord-datas")
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      console.log(response.data)
      if (response.data.success) {

      this.dataz = response.data.dataz;
       
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
    async handleAssign(order) {

      const staffId = this.selectedStaff;
      if (!staffId) return;

      const staff = this.staffs.find(s => s.id === staffId);

      const confirmAssign = window.confirm(
        `Are you sure you want to assign ${staff.username}?`
      );

      if (!confirmAssign) {
        window.location.reload()
      }else{

      var status = 2
      var order_id = order.id
      var sale_by = staff.id
      var comment = ""
     
      // update status 
      var response = await axios.post(this.$store.state.api_url + "/update-order-status",{status, order_id, sale_by, comment})
      .catch((errors) => {
        var message = "Network or Request Errors";
        alert(message)
        //this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
       // alert('Cuccessfully')

        window.location.reload()
      } else {
        alert(response.data.message)
      }
    }
      
    }

  },
  created() {
    this.$store.state.page_name = "Dashbord"
    this.dashbordDatas()
    this.getOrders()
    this.getStaffs()
  },
};
</script>
